import { Layout } from 'antd';
import { Row, Col } from 'antd';
import { QuestionCircleOutlined } from "@ant-design/icons";
import TextContent from 'resources/Text-content.json';
import logo from 'assets/images/logo.svg';
import './header.scss';

const { Header } = Layout;

const HeaderComponent = () => {
    return (
        <Header className="header-wrapper">
            <Row>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10 }} lg={{ span: 10 }} xl={{ span: 10 }}>
                    <img src={logo} />
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 14 }} lg={{ span: 14 }} xl={{ span: 14 }}>
                    <div className="title">
                        {TextContent?.deployment_config}
                        <span className="position">
                            <QuestionCircleOutlined />
                        </span>
                    </div>
                </Col>
            </Row>
        </Header>
    )
}

export default HeaderComponent;